import { z } from 'zod';
/** ACS-3: an admin also manages the team and scope. */
export const teamRoleSchema = z.enum(['admin', 'member']);
/** ACS-001 AC-10: where a person's sign-in stands. */
export const signInStatusSchema = z.enum(['no-email', 'not-invited', 'invited', 'signed-in']);
export const teamPersonSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    initials: z.string(),
    avatarColour: z.string(),
    /** Null for people who aren't developers. */
    githubLogin: z.string().nullable(),
    emailAddress: z.string().nullable(),
    role: teamRoleSchema,
    status: signInStatusSchema,
    /** "27 Sep": when they were invited, or first signed in (New York time); null otherwise. */
    sinceLabel: z.string().nullable(),
    /** The admin looking at the page: they can't change their own role or remove themselves. */
    self: z.boolean(),
});
/** The Team page (ACS-001, ACS-002): the roster's people, and the agents that never sign in. */
export const teamResponseSchema = z.object({
    people: z.array(teamPersonSchema),
    agents: z.array(z.object({ displayName: z.string(), initials: z.string(), avatarColour: z.string(), githubLogin: z.string().nullable() })),
});
const optional = (schema) => z.preprocess((value) => (typeof value === 'string' && value.trim() === '' ? null : value), schema.nullable());
/** A person's details, as an admin enters them (ACS-001 AC-2, AC-4). */
export const teamPersonBodySchema = z.object({
    displayName: z.string().trim().min(1, 'Give their name.').max(100),
    emailAddress: optional(z.string().trim().toLowerCase().email("That email doesn't look right.")),
    githubLogin: optional(z.string().trim().max(39).regex(/^[A-Za-z0-9-]+$/, "That GitHub login doesn't look right.")),
    role: teamRoleSchema,
});
/** Adding a person, and inviting them in the same step when `invite` is set (ACS-001 AC-2). */
export const addTeamPersonBodySchema = teamPersonBodySchema.extend({ invite: z.boolean().default(false) });
//# sourceMappingURL=team.js.map